'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var injectSheet = require('react-jss');
var ButtonElement = require('pobble-components/dist/button-element');
var teacher = require('pobble-components/dist/select-role/teacher.svg');
var parent = require('pobble-components/dist/select-role/parent.svg');
var student = require('pobble-components/dist/select-role/student.svg');
var schoolLeader = require('pobble-components/dist/select-role/school-leader.svg');
var englishLeader = require('pobble-components/dist/select-role/english-leader.svg');
var other = require('pobble-components/dist/select-role/other.svg');
var classNames = require('classnames');
var _extends = require('@babel/runtime/helpers/extends');
var Button = require('pobble-components/dist/button');
var api = require('pobble-components/dist/api');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var ButtonElement__default = /*#__PURE__*/_interopDefaultLegacy(ButtonElement);
var teacher__default = /*#__PURE__*/_interopDefaultLegacy(teacher);
var parent__default = /*#__PURE__*/_interopDefaultLegacy(parent);
var student__default = /*#__PURE__*/_interopDefaultLegacy(student);
var schoolLeader__default = /*#__PURE__*/_interopDefaultLegacy(schoolLeader);
var englishLeader__default = /*#__PURE__*/_interopDefaultLegacy(englishLeader);
var other__default = /*#__PURE__*/_interopDefaultLegacy(other);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#25408F",
    d: "M8.833 11.5 7.042 9.708a.79.79 0 0 0-.584-.229.79.79 0 0 0-.583.23.79.79 0 0 0-.23.583c0 .236.077.43.23.583L8.25 13.25a.8.8 0 0 0 .583.25.8.8 0 0 0 .584-.25l4.708-4.708a.79.79 0 0 0 .23-.584.79.79 0 0 0-.23-.583.79.79 0 0 0-.583-.23.79.79 0 0 0-.584.23L8.833 11.5ZM10 18.333a8.111 8.111 0 0 1-3.25-.656 8.428 8.428 0 0 1-2.646-1.781 8.41 8.41 0 0 1-1.78-2.646A8.13 8.13 0 0 1 1.666 10a8.11 8.11 0 0 1 .656-3.25 8.428 8.428 0 0 1 1.781-2.646 8.41 8.41 0 0 1 2.646-1.78A8.13 8.13 0 0 1 10 1.666a8.11 8.11 0 0 1 3.25.656 8.428 8.428 0 0 1 2.646 1.781 8.422 8.422 0 0 1 1.782 2.646 8.099 8.099 0 0 1 .655 3.25 8.11 8.11 0 0 1-.656 3.25 8.426 8.426 0 0 1-1.781 2.646 8.421 8.421 0 0 1-2.646 1.781 8.099 8.099 0 0 1-3.25.656Z"
  }));
};

var RoleButton = injectSheet__default["default"]({
  button: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#fff',
    borderRadius: '8px',
    border: '1px solid #D6D7DF',
    padding: '24px',
    height: '200px',
    width: '100%',
    boxShadow: '0 1px 2px rgba(0, 0, 0, .1)',
    '&:hover, &:focus': {
      boxShadow: '0 0 0 2px rgba(37, 64, 143, .2), 0 1px 2px rgba(0, 0, 0, .1)'
    },
    '@media (min-width: 768px)': {
      width: '208px'
    },
    '& *': {
      pointerEvents: 'none'
    }
  },
  check: {
    position: 'absolute',
    top: '8px',
    right: '8px'
  },
  title: {
    margin: '0',
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'var(--gray)',
    lineHeight: '1.2'
  },
  description: {
    margin: '0',
    fontSize: '12px',
    color: 'var(--gray--)',
    lineHeight: '1.2',
    maxWidth: '160px',
    '@media (min-width: 768px)': {
      minHeight: '28px'
    }
  },
  text: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  active: {
    borderColor: '#25408F',
    boxShadow: '0 0 0 2px rgba(37, 64, 143, .2), 0 1px 2px rgba(0, 0, 0, .1)'
  }
})(function (_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      description = _ref.description,
      icon = _ref.icon,
      active = _ref.active,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/React__default["default"].createElement(ButtonElement__default["default"], {
    onClick: onClick,
    className: classNames__default["default"](classes.button, _defineProperty__default["default"]({}, classes.active, active), className)
  }, active && /*#__PURE__*/React__default["default"].createElement(SvgComponent, {
    className: classes.check
  }), icon, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.text
  }, /*#__PURE__*/React__default["default"].createElement("h3", {
    className: classes.title
  }, title), /*#__PURE__*/React__default["default"].createElement("p", {
    className: classes.description
  }, description)));
});
var SelectRole = injectSheet__default["default"]({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
    alignItems: 'center',
    textAlign: 'center',
    padding: '24px'
  },
  options: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'grid',
    gridTemplateColumns: '1fr',
    width: '100%',
    gap: '16px',
    '@media (min-width: 768px)': {
      gridTemplateColumns: '1fr 1fr 1fr'
    }
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    gap: '16px',
    alignItems: 'center',
    '& h2': {
      margin: '0',
      color: 'var(--gray)'
    },
    '& p': {
      margin: '0',
      color: 'var(--gray-)',
      font: 'var(--body-)'
    }
  },
  button: {
    minWidth: '160px'
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    alignItems: 'center'
  }
})(function (_ref2) {
  var classes = _ref2.classes,
      onSuccess = _ref2.onSuccess,
      onError = _ref2.onError,
      description = _ref2.description;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray__default["default"](_useState3, 2),
      pending = _useState4[0],
      setPending = _useState4[1];

  function setRole() {
    setPending(true);
    api.apiClient.post("/v3/me/role_in_life", {
      role_in_life: active
    }).then(function () {
      var success = onSuccess && onSuccess();

      if (success.then) {
        success.then(function () {
          return setPending(false);
        });
      } else {
        setPending(false);
      }
    })["catch"](function () {
      setPending(false);
      onError();
    });
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.container
  }, !description ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.description
  }, /*#__PURE__*/React__default["default"].createElement("h2", {
    className: classes.title
  }, "Which of these", /*#__PURE__*/React__default["default"].createElement("br", null), "best describes your role?")) : description, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    className: classes.options
  }, /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(RoleButton, {
    className: "metrics__role--teacher_in_school",
    active: active === 'teacher_in_school',
    onClick: function onClick() {
      return setActive('teacher_in_school');
    },
    title: "Teacher",
    description: "I teach students whom I want to inspire to write",
    icon: /*#__PURE__*/React__default["default"].createElement("img", {
      src: teacher__default["default"],
      alt: "Teacher"
    })
  })), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(RoleButton, {
    className: "metrics__role--english_leader_in_school",
    active: active === 'english_leader_in_school',
    onClick: function onClick() {
      return setActive('english_leader_in_school');
    },
    title: "English leader",
    description: "I lead on English or writing in an educational setting",
    icon: /*#__PURE__*/React__default["default"].createElement("img", {
      src: englishLeader__default["default"],
      alt: "Teacher"
    })
  })), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(RoleButton, {
    className: "metrics__role--school_administrator",
    active: active === 'school_administrator',
    onClick: function onClick() {
      return setActive('school_administrator');
    },
    title: "School leader",
    description: "I am responsible for teachers in an educational setting",
    icon: /*#__PURE__*/React__default["default"].createElement("img", {
      src: schoolLeader__default["default"],
      alt: "Teacher"
    })
  })), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(RoleButton, {
    className: "metrics__role--parent",
    active: active === 'parent',
    onClick: function onClick() {
      return setActive('parent');
    },
    title: "Parent",
    description: "I have children I want to inspire to write",
    icon: /*#__PURE__*/React__default["default"].createElement("img", {
      src: parent__default["default"],
      alt: "Teacher"
    })
  })), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(RoleButton, {
    className: "metrics__role--student",
    active: active === 'student',
    onClick: function onClick() {
      return setActive('student');
    },
    title: "Student / Child",
    description: "I would like to improve my writing",
    icon: /*#__PURE__*/React__default["default"].createElement("img", {
      src: student__default["default"],
      alt: "Teacher"
    })
  })), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(RoleButton, {
    className: "metrics__role--other",
    active: active === 'other',
    onClick: function onClick() {
      return setActive('other');
    },
    title: "Other",
    description: "I am doing something else",
    icon: /*#__PURE__*/React__default["default"].createElement("img", {
      src: other__default["default"],
      alt: "Teacher"
    })
  }))), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    action: setRole,
    disabled: !active,
    pending: pending,
    darkBlue: true,
    tall: true,
    minw: true,
    className: classes.button
  }, pending ? 'Saving...' : 'Complete my account')));
});

exports.SelectRole = SelectRole;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/select-role/index.js